/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import React from 'react';
import classNames from 'classnames';
import { CloseIcon } from 'tdesign-icons-react';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { useMessageClass } from './useMessageClass.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-46de7b2e.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';

function MessageClose(_ref) {
  var closeBtn = _ref.closeBtn,
    onCloseBtnClick = _ref.onCloseBtnClick;
  var _useMessageClass = useMessageClass(),
    tdMessageClassGenerator = _useMessageClass.tdMessageClassGenerator;
  var _useGlobalIcon = useGlobalIcon({
      CloseIcon: CloseIcon
    }),
    CloseIcon$1 = _useGlobalIcon.CloseIcon;
  var relCloseBtn = closeBtn;
  if (typeof closeBtn === "function") {
    relCloseBtn = closeBtn();
  }
  if (!relCloseBtn) {
    return null;
  }
  if (typeof relCloseBtn === "string" || typeof relCloseBtn === "number") {
    return /* @__PURE__ */React.createElement("span", {
      className: tdMessageClassGenerator("close"),
      onClick: function onClick(e) {
        return onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
          e: e
        });
      }
    }, closeBtn);
  }
  if ( /*#__PURE__*/React.isValidElement(relCloseBtn)) {
    var _onClick = relCloseBtn.props.onClick;
    return /*#__PURE__*/React.cloneElement(relCloseBtn, {
      className: classNames(relCloseBtn.props.className, tdMessageClassGenerator("close")),
      onClick: function onClick(e) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
        onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
          e: e
        });
      }
    });
  }
  return /* @__PURE__ */React.createElement(CloseIcon$1, {
    className: tdMessageClassGenerator("close"),
    onClick: function onClick(e) {
      return onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
        e: e
      });
    }
  });
}

export { MessageClose as default };
//# sourceMappingURL=MessageClose.js.map
